<template>
  <div class="big-customer-info" v-loading="infoLoading">
      <div class="sec-hd">
        <h2 class="title">大客户信息</h2>
        <div class="btn-group" v-if="!(typeof(actionData.customerghkh_editandsave) != 'undefined'&&!actionData.customerghkh_editandsave)">
          <el-button type="primary" size="medium" @click="submit">保存</el-button>
        </div>
      </div>
      <el-collapse v-model="activeNames" v-if="!infoLoading">
        <el-collapse-item title="商务合同" name="1">
          <el-form label-width="150px" class="contract-form" label-position="left" size="medium ">
            <el-row :gutter="20">
              <el-col :lg="12">
                <el-form-item label="是否有额度：">
                  <el-select v-model="contractForm.IsCreditEnterprise" value-key="label" placeholder="请选择">
                    <el-option :value="true" label="有"></el-option>
                    <el-option :value="false" label="无"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item label="总额度：" v-show="contractForm.IsCreditEnterprise==1">
                  <el-input v-model.number="contractForm.CreditLineTotalValue"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item label="合同约定充值额：" v-show="contractForm.IsCreditEnterprise!=1">
                  <el-input v-model.number="contractForm.RechargeAmount"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item label="是否具有合同：">
                  <el-radio-group v-model="contractForm.IsExist">
                    <el-radio :label="true">有</el-radio>
                    <el-radio :label="false">无</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item label="签约期：" v-show="contractForm.IsExist==1">
                  <el-select v-model="contractForm.SigningPeriod" value-key="label" placeholder="请选择">
                    <el-option v-for="item in period" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item label="合同签订日：" v-show="contractForm.IsExist==1">
                  <el-date-picker
                    v-model="contractForm.SignStartTime"
                    type="date"
                    format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item label="合同到期日：" v-show="contractForm.IsExist==1">
                  <el-date-picker
                    v-model="contractForm.SignEndTime"
                    type="date"
                    format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item label="合同编号：" v-show="contractForm.IsExist==1">
                  <el-input v-model.trim="contractForm.ContractNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item label="账期：" v-show="contractForm.IsCreditEnterprise==1 && contractForm.IsExist==1">
                  <el-input class="has-unit" v-model.trim="contractForm.PaymentDays"></el-input>
                  <span class="unit">天</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-collapse-item>
        <template v-for="(item,index) in priceConfig">
        <el-collapse-item :title="item.ProductCategoryLv1Name" :name="'p'+index" :key="index">
          <el-form label-width="150px" class="price-form" label-position="left" size="medium ">
            <el-form-item label="发单方结算" class="first-item">
              <el-radio-group v-model="item.TimeUnit">
                <el-radio :label="2">按天</el-radio>
                <el-radio :label="1">按小时</el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-show="item.TimeUnit==2">
              <el-form-item label="工作日：">
                <el-input class="inline" v-model.number="item.WorkdayPrice"></el-input>
                <span class="unit">元/天/人</span>
              </el-form-item>
              <el-form-item label="周末：">
                <el-input class="inline" v-model.number="item.WeekendPrice"></el-input>
                <span class="unit">元/天/人</span>
              </el-form-item>
              <el-form-item label="节假日：">
                <el-input class="inline" v-model.number="item.HolidayPrice"></el-input>
                <span class="unit">元/天/人</span>
              </el-form-item>
            </div>
            <div v-show="item.TimeUnit==1">
              <el-form-item label="工作日：">
                <div class="inner-form-item">
                  <span class="label">出发价格：</span>
                  <el-input class="inline" v-model.number="item.WorkdayDepartHourPrice"></el-input>
                  <span class="unit">元/小时/人</span>
                </div>
                <div class="inner-form-item">
                  <span class="label">返程价格：</span>
                  <el-input class="inline" v-model.number="item.WorkdayBackHourPrice"></el-input>
                  <span class="unit">元/小时/人</span>
                </div>
                <div class="inner-form-item">
                  <span class="label">工作价格：</span>
                  <el-input class="inline" v-model.number="item.WorkdayWorkHourPrice"></el-input>
                  <span class="unit">元/小时/人</span>
                </div>
              </el-form-item>
              <el-form-item label="周末：">
                <div class="inner-form-item">
                  <span class="label">出发价格：</span>
                  <el-input class="inline" v-model.number="item.WeekendDepartHourPrice"></el-input>
                  <span class="unit">元/小时/人</span>
                </div>
                <div class="inner-form-item">
                  <span class="label">返程价格：</span>
                  <el-input class="inline" v-model.number="item.WeekendBackHourPrice"></el-input>
                  <span class="unit">元/小时/人</span>
                </div>
                <div class="inner-form-item">
                  <span class="label">工作价格：</span>
                  <el-input class="inline" v-model.number="item.WeekendWorkHourPrice"></el-input>
                  <span class="unit">元/小时/人</span>
                </div>
              </el-form-item>
              <el-form-item label="节假日：">
                <div class="inner-form-item">
                  <span class="label">出发价格：</span>
                  <el-input class="inline" v-model.number="item.HolidayDepartHourPrice"></el-input>
                  <span class="unit">元/小时/人</span>
                </div>
                <div class="inner-form-item">
                  <span class="label">返程价格：</span>
                  <el-input class="inline" v-model.number="item.HolidayBackHourPrice"></el-input>
                  <span class="unit">元/小时/人</span>
                </div>
                <div class="inner-form-item">
                  <span class="label">工作价格：</span>
                  <el-input class="inline" v-model.number="item.HolidayWorkHourPrice"></el-input>
                  <span class="unit">元/小时/人</span>
                </div>
              </el-form-item>
            </div>
            <div v-for="(overTime,idx) in item.OverTimeSetList" :key="idx">
              <el-form-item :label="overTime.HolidayType==1?'工作日加班：':overTime.HolidayType==2?'周末加班：':'节假日加班：'">
                <el-radio-group v-model="overTime.IsHasOvertimeSetting">
                  <el-radio :label="0">无</el-radio>
                  <el-radio :label="1">有</el-radio>
                </el-radio-group>
                <div class="inner-form-item" v-show="overTime.IsHasOvertimeSetting==1">
                  <el-time-select
                    v-model="overTime.MorningEndTime"
                    :picker-options="timeOption"
                    placeholder="选择时间">
                  </el-time-select>
                  <span class="unit">以前</span>
                </div>
                <div class="inner-form-item" v-show="overTime.IsHasOvertimeSetting==1">
                  <el-time-select
                    v-model="overTime.EeveningStartTime"
                    :picker-options="timeOption"
                    placeholder="选择时间">
                  </el-time-select>
                  <span class="unit">以后</span>
                </div>
                <div class="inner-form-item" v-show="overTime.IsHasOvertimeSetting==1">
                  <span class="unit">加班价格：</span>
                  <el-input class="inline" v-model.number="overTime.OverTimeHourPrice"></el-input>
                  <span class="unit">元/小时/人</span>
                </div>
              </el-form-item>
            </div>
            <el-form-item label="结算最小单位：">
              <el-radio-group v-model="item.SettlementUnit">
                <el-radio :label="1">1小时</el-radio>
                <el-radio :label="2">0.5小时</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-collapse-item>
        </template>
        <el-collapse-item title="其他" name="3">
          <el-form label-width="150px" class="other-form" label-position="left" size="medium">
            <el-row :gutter="20">
              <el-col :lg="12">
                <el-form-item label="发单价格含税">
                  <el-radio-group v-model="otherForm.IsSTaxIncluded">
                    <el-radio :label="true">有</el-radio>
                    <el-radio :label="false">无</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :lg="12">
                <el-form-item label="特殊地区上涨幅度：">
                  <el-input-number v-model="otherForm.RegionalIncrease" controls-position="right" :min="0" :max="100"></el-input-number>
                  <span class="unit">%</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="特殊地区：">
              <span class="area-item" v-for="(item,index) in specialArea" :key="index">
                {{item.CityName || item.ProvinceName}}
                <i class="icon-remove" @click="removeDistrict(index)">×</i>
              </span>
              <span class="btn-add el-icon-plus" @click="isShowCascader=true"></span>
            </el-form-item>
            <el-form-item label="异地补助：">
              <el-radio-group v-model="otherForm.DiffCitySubsidy">
                <el-radio :label="item.value" v-for="item in subsidyRule" :key="item.value">{{item.label}}</el-radio>
              </el-radio-group>
              <template v-if="otherForm.DiffCitySubsidy==4">
                <el-input class="inline" v-model.number="otherForm.DiffCityFixedSubsidy"></el-input>
                <span class="unit">元/天/人</span>
              </template>
              <div class="tips">注：实报实销需要上传证据，且需加收6%的税点</div>
            </el-form-item>
            <el-form-item label="同城补助：">
              <el-radio-group v-model="otherForm.CitySubsidy">
                <el-radio :label="item.value" v-for="item in subsidyRule" :key="item.value">{{item.label}}</el-radio>
              </el-radio-group>
              <template v-if="otherForm.CitySubsidy==4">
                <el-input class="inline" v-model.number="otherForm.FixedSubsidy"></el-input>
                <span class="unit">元/天/人</span>
              </template>
              <div class="tips">注：实报实销需要上传证据，且需加收6%的税点</div>
            </el-form-item>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <el-dialog
        width="500px"
        center
        :visible.sync="isShowCascader"
      >
        <el-form label-width="100">
          <el-form-item label="地址">
            <el-cascader-panel
              :options="province"
              :props="options"
              ref="cascader"
              clearable>
            </el-cascader-panel>
          </el-form-item>
        </el-form>
        <div class="dialog-footer" slot="footer">
          <el-button type="primary" @click="confirmDistrict">确定</el-button>
        </div>
      </el-dialog>
  </div>
</template>
<script>
import { PERIOD,SUBSIDY } from '@/config/const/common.js'
import {
  GetBigCustomerConfig,
  AddBigCustomerConfig
} from '@/service/customerInformation.js';
import {
  optionsArea,
} from '@/service/area.js';
import { 
    getActionData
} from '@/utils/store'
export default {
  data(){
    return{
      actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
      infoLoading: false,

      activeNames: ['1','p0','p1','p2','p3','3'],//折叠
      //合同表单
      contractForm:{
        IsExist:1,
        ConTractID:0,
        IsCreditEnterprise:'',
        CreditLineTotalValue:'',
        RechargeAmount:'',
        SalePersonName:'',
        SalePersonId:'',
        SaleCompanyName:'',
        SaleCompanyId:'',
        SigningPeriod:'',
        SignStartTime:'',
        SignEndTime:'',
        ContractNo:'',
        PaymentDays:'',
      },
      //其他表单
      otherForm:{
        IsSTaxIncluded:0,
        RegionalIncrease:0,
        DiffCitySubsidy:1,
        DiffCityFixedSubsidy:0,
        CitySubsidy:1,
        FixedSubsidy:0,
      },
      timeOption:{
        start: '06:00',
        step: '00:30',
        end: '20:00',
      },
      priceConfig:[],
      hasContract:1,
      options:{ 
        // multiple: true, //多选
        checkStrictly: true,//父子节点不相关联
        emitPath:true,//返回各级节点组成的数组
        lazy:true,
        lazyLoad(node,resolve){
          if(node.level==1){
            //根据选择的省节点，加载市节点
            optionsArea({
              aid:node.value,
              areaType:2
            }).then(r=>{
              console.log(node);
              if(r.Result==1){
                let list=r.Data ||[];
                list.map(item=>{
                  item['label']=item.areaname;
                  item['value']=item.aid;
                  item['leaf']=true
                })
                resolve(list);
              }else{
                resolve([])
              }
            })
          }else{
            resolve([])
          }
        }
      },
      province:[],//省列表
      specialArea:[],//特殊地区
      isShowCascader:false,
      period:PERIOD,//签约期列表
      subsidyRule:SUBSIDY,//补助规则
    }
  },
  created() {
    this.pageInit();
    this.loadData();
  },
  methods: {
    pageInit(){
      //获取省列表
      optionsArea({
        aid:0,
        areaType:1
      }).then(r=>{
        if(r.Result==1){
          let list=r.Data || [];
          list.map(item=>{
            item['label']=item.areaname;
            item['value']=item.aid;
          })
          this.province=list;
        }
      })
    },
    loadData(){
      this.infoLoading = true
      GetBigCustomerConfig({
        CompanyId:this.$route.query.companyId,
      }).then(r=>{
        this.infoLoading = false
        if(r.Result==1){
          this.contractForm={...r.Data.Contract};
          for (const k in this.contractForm) {
            if (Object.hasOwnProperty.call(this.contractForm, k)) {
              this.contractForm[k]=r.Data.Contract[k];
            }
          }
          for (const k in this.otherForm) {
            if (Object.hasOwnProperty.call(this.otherForm, k)) {
              this.otherForm[k]=r.Data.OtherConfig[k];
            }
          }
          this.priceConfig=r.Data.JobPriceConfigList;
          this.specialArea=r.Data.OtherConfig.SpecialAreaList ||[];
        }else{
          this.$message.info(r.Message);
        }
      })
    },
    //确认添加特殊地址
    confirmDistrict(){
      let nodes=this.$refs.cascader.getCheckedNodes();
      let node=nodes[0];
      if(node && node.level==1){
          //选择只有省
        this.specialArea = this.specialArea.filter(item => {
            if (item.ProvinceID != node.value) {
                return true
            }
        })
        let obj={
          ProvinceID:node.value,
          ProvinceName:node.label,
          CityID:0,
          CityName:'',
        }
        this.specialArea.push(obj);
      }
      if (node && node.level==2) {
          //选择有省和市
          let obj={
            ProvinceID:node.parent.value,
            ProvinceName:node.parent.label,
            CityID:node.value,
            CityName:node.label,
          }
          for (var i = 0; i < this.specialArea.length; i++) {
              if (this.specialArea[i].ProvinceID == node.parent.value && this.specialArea[i].CityID == '') {
                  this.specialArea.splice(i, 1); //如果已经有省，则删除省
              }
              if (this.specialArea[i].CityID == node.value) {
                  this.specialArea.splice(i, 1); //如果已经有市，则删除市
              }
          }
          this.specialArea.push(obj);
      }
      this.$refs.cascader.clearCheckedNodes();
      this.isShowCascader=false;
    },
    //删除特殊地址
    removeDistrict(index) {
        this.specialArea.splice(index, 1);
    },
    submit(){
      this.otherForm['SpecialAreaList']=this.specialArea;
      let params={
        BigCustomerConfig:{
          CompanyId:this.$route.query.companyId,
          Contract:this.contractForm,
          JobPriceConfigList:this.priceConfig,
          OtherConfig:this.otherForm
        }
      }
      AddBigCustomerConfig(params).then(r=>{
        if(r.Result==1){
          this.$message.success('保存成功');
          this.loadData();
        }else{
          this.$message.info(r.Message);
        }
      })
      console.log(this.priceConfig)
    },
  },
}
</script>
<style lang="scss">
.big-customer-info{
  .sec-hd{
		overflow: hidden;
		margin-bottom: 20px;
		.title{
			font-size: 18px;
			color: #333;
			line-height: 40px;
			font-weight: bold;
      float: left;
		}
    .btn-group{
      float: right;
    }
	}
  .el-collapse-item__header{
    background-color: #f5f5f5;
    padding-left: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  .unit{
    font-size: 14px;
    color: #333;
    line-height: 36px;
    padding-left: 3px;
  }
  .inline{
    display: inline-block;
    width: auto;
  }
  .el-form-item__label{
    font-size: 14px;
    font-weight: bold;
    padding-left: 10px;
    box-sizing: border-box;
  }
  .el-radio-group{
    margin-right: 20px;
  }
  .contract-form,.other-form{
    padding-top: 10px;
    .el-select,
    .el-cascader,
    .el-date-editor{
      width: 100%;
    }
    .has-unit{
      width: calc(100% - 20px);
    }
  }
  .price-form{
    .first-item .el-form-item__label{
      font-size: 16px;
      font-weight: bold;
      position: relative;
      padding-left: 20px;
      &:before{
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -8px;
        height: 16px;
        width: 4px;
        background-color: #f75959;
      }
      .block{
        display: inline-block;
      }
    }
    .inner-form-item{
      white-space: nowrap;
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
    }
  }
  .area-item{
    position: relative;
    display: inline-block;
    vertical-align: middle;
    height: 36px;
    line-height: 36px;
    padding: 0 16px;
    background-color: #29c4b6;
    border-radius: 4px;
    margin-right: 10px;
    color: #fff;
    &:hover{
      .icon-remove{
        display: block;
      }
    }
    .icon-remove{
      position: absolute;
      right: 0;
      top: 0;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      cursor: pointer;
      display: none;
    }
  }
  .btn-add{
    position: relative;
    display: inline-block;
    vertical-align: middle;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    border: 1px solid #29c4b6;
    background-color: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    font-size: 16px;
    color: #29c4b6;
    &:hover{
      background-color: #29c4b6;
      color: #fff;
    }
  }
}
</style>